<template>
    <div class="home-page">
          <animated-background></animated-background>
          <our-services></our-services>
          <latest-activities></latest-activities>
          <latest-products></latest-products>
          <our-clients></our-clients>
          <f-section></f-section>
    </div>
</template>

<script>
import AnimatedBackground from '@/components/home/animated-background';
import LatestProducts from '@/components/home/latest-products';
import OurClients from '@/components/home/our-clients';
import FSection from '@/components/home/f-section';
import LatestActivities from '@/components/home/latest-activities';
import OurServices from '@/components/home/our-services';

export default {
    name:'Home',

    components: {
        AnimatedBackground,
        LatestProducts,
        OurClients,
        FSection,
        LatestActivities,
        OurServices
    }
}
</script>



// WEBPACK FOOTER //
// src/components/home/home.vue